var Common = {};
var activeClassName = "n_active";
var parentStyleClassName = "parentStyle";
var styleItemClassName = "_5118editor";

Common.install = function(Vue) {
  // 3. 注入组件
  Vue.mixin({
    methods: {
      rgb2hex: function(rgb) {
        var reg = /(\d{1,3}),(\d{1,3}),(\d{1,3})/;
        var arr = reg.exec(rgb);

        function hex(x) {
          return ("0" + parseInt(x).toString(16)).slice(-2);
        }
        var _hex = "#" + hex(arr[1]) + hex(arr[2]) + hex(arr[3]);
        return _hex.toUpperCase();
      },
      // 4. 添加实例方法
      hasClass: function(elements, cName) {
        if (
          elements != null &&
          elements.className !== null &&
          elements.className.match !== undefined
        ) {
          //console.log(elements)
          return !!elements.className.match(
            new RegExp("(\\s|^)" + cName + "(\\s|$)")
          );
        }

        return false;
      },
      addClass: function(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
      },
      removeClass: function(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(
            new RegExp("(\\s|^)*" + cName + "(\\s|$)*"),
            " "
          );
        }
      },
      activeItem: function(selectedItem, doc) {
        this.deactiveItem(doc);

        //将所选的所有的父子级样式都给active样式
        var firstFoundStyleItemParent = null;
        // eslint-disable-next-line no-constant-condition
        while (true) {
          var styleItemParent = this.getStyleItemParent(selectedItem);
          if (styleItemParent == null) {
            break;
          } else {
            this.current_active_item = styleItemParent;

            this.addClass(this.current_active_item, activeClassName);
          }

          if (firstFoundStyleItemParent == null) {
            //修正激活的元素
            // "<section class='parentStyle' style='margin: 0px auto; width: 100%;'><p style='display: block;'/>" +
            //     this.insertHtml +
            //     "<p style='display: block;'/></section><br />&nbsp;";

            if (
              this.hasClass(
                styleItemParent.parentNode,
                parentStyleClassName
              ) === false
            ) {
              var parentStyleSection = document.createElement("section");
              this.addClass(parentStyleSection, parentStyleClassName);

              parentStyleSection.style.cssText =
                "margin: 0px auto; width: 100%;";

              //先将新的包围放到样式元素之前

              //console.log(styleItemParent)
              this.insertAfter(parentStyleSection, styleItemParent);

              //完善包围里的元素
              var parentStyleChildP1 = document.createElement("p");
              parentStyleChildP1.style.cssText = "display: block;";
              parentStyleChildP1.innerHTML = "<br>";

              parentStyleSection.appendChild(parentStyleChildP1);

              //将原来的样式放入包围
              parentStyleSection.appendChild(styleItemParent);

              var parentStyleChildP2 = document.createElement("p");
              parentStyleChildP2.style.cssText = "display: block;";
              parentStyleChildP2.innerHTML = "<br>";

              parentStyleSection.appendChild(parentStyleChildP2);
            }

            firstFoundStyleItemParent = styleItemParent;
          }
          selectedItem = styleItemParent;
        }

        return firstFoundStyleItemParent;
      },

      deactiveItem: function(doc) {
        //console.log(doc);

        if (this.current_active_item !== undefined) {
          this.removeClass(this.current_active_item, activeClassName);

          var els = doc.querySelectorAll("." + activeClassName);

          for (let i = 0; i < els.length; ++i) {
            this.removeClass(els[i], activeClassName);
          }
        }
      },

      getStyleItemParent: function(elem) {
        let styleItem = null;

        while (elem.parentNode && elem.parentNode.tagName !== "BODY") {
          if (this.hasClass(elem.parentNode, styleItemClassName)) {
            //console.log('找到了：' + elem.tagName)
            styleItem = elem.parentNode;
            break;
          }

          //console.log("寻找" + elem.tagName)
          elem = elem.parentNode;
        }

        return styleItem;
      },
      findStyleItemRootWithStyle: function(elem) {
        let styleItem = null;

        while (elem.parentNode && elem.parentNode.tagName !== "BODY") {
          if (this.hasClass(elem.parentNode, styleItemClassName)) {
            //console.log('找到了：' + elem.tagName)
            styleItem = elem.parentNode;
          }

          //console.log("寻找" + elem.tagName)
          elem = elem.parentNode;
        }

        return styleItem;
      },
      setVendor: function(element, property, value) {
        element.style[property] = value;
        element.style["webkit" + property] = value;
        element.style["moz" + property] = value;
        element.style["ms" + property] = value;
        element.style["o" + property] = value;
      },
      insertAfter: function(newElement, targetElement) {
        var parent = targetElement.parentNode;
        //console.log(parent)
        if (parent.lastChild == targetElement) {
          parent.appendChild(newElement);
        } else {
          parent.insertBefore(newElement, targetElement.nextSibling);
        }
      },
      insertBefore: function(newElement, targetElement) {
        targetElement.parentNode.insertBefore(newElement, targetElement);
      },
      flashBackground: function(element) {
        var colorFlag = 0;
        var flashCount = 0;

        var temp = this;

        var flashInterval = setInterval(function() {
          if (!colorFlag) {
            //element.style.background = "#ff0000EE";
            temp.addClass(element, "attention");
            colorFlag = 1;
          } else {
            //element.style.background = "";
            temp.removeClass(element, "attention");
            colorFlag = 0;
          }
          flashCount++;
          if (flashCount > 5) {
            temp.removeClass(element, "attention");
            clearInterval(flashInterval);
          }
        }, 200);
      },
      getAllChildNode: function(allNodes, node) {
        //先找到子结点
        var nodeList = node.childNodes;
        for (let i = 0; i < nodeList.length; i++) {
          //childNode获取到到的节点包含了各种类型的节点
          //但是我们只需要元素节点  通过nodeType去判断当前的这个节点是不是元素节点
          var childNode = nodeList[i];
          //判断是否是元素结点
          if (childNode.nodeType === 1) {
            //childNode.style.border = "1px solid blue";
            allNodes.push(childNode);

            this.getAllChildNode(allNodes, childNode);
          }
        }
      },
      getAllSiblingsNodes: function(elm) {
        var a = []; //保存所有兄弟节点
        var p = elm.parentNode.children; //获取父级的所有子节点
        for (let i = 0; i < p.length; i++) {
          //循环
          if (p[i].nodeType === 1 && p[i] !== elm) {
            //如果该节点是元素节点与不是这个节点本身
            a.push(p[i]); // 添加到兄弟节点里
          }
        }

        return a;
      },
      getAllSiblingsNodesAfter: function(elm) {
        var a = []; //保存所有兄弟节点
        var p = elm.parentNode.children; //获取父级的所有子节点
        var startPush = false;
        for (let i = 0; i < p.length; i++) {
          //循环

          if (startPush) {
            a.push(p[i]); // 添加到兄弟节点里
          }

          if (p[i].nodeType === 1 && p[i] === elm) {
            //如果该节点是元素节点与不是这个节点本身
            startPush = true;
          }
        }

        return a;
      },
      getAllSiblingsNodesBefore: function(elm) {
        var a = []; //保存所有兄弟节点

        var p = elm.parentNode.children; //获取父级的所有子节点

        for (let i = 0; i < p.length; i++) {
          //循环
          if (p[i].nodeType === 1) {
            //如果该节点是元素节点与不是这个节点本身
            if (p[i] !== elm) {
              a.push(p[i]); // 添加到兄弟节点里
            } else {
              break;
            }
          }
        }

        return a;
      },
      reverseArray: function(arr) {
        for (let i = 0; i < arr.length / 2; i++) {
          var tem = arr[i];
          arr[i] = arr[arr.length - 1 - i];
          arr[arr.length - 1 - i] = tem;
        }

        return arr;
      },
      selectionContent: function() {
        var range;
        if (document.getSelection) {
          range =
            (document.getSelection().anchorNode &&
              document.getSelection().getRangeAt(0)) ||
            "";
        } else if (document.selection && document.selection.createRange) {
          range = document.selection.createRange().text;
        }
        if (range === "") {
          return "";
        }
        return range.cloneContents();
      },
      SendMessage(sendData) {
        this.$nextTick(() => {
          let wycBox = window._5118_Wyc_Box;
          wycBox.contentWindow.postMessage(sendData, "*");
        });
      },
      sendNewMsg(type, msg) {
        let wyciframe = window._5118_Wyc_Box;
        this.$messenger.addTarget(wyciframe.contentWindow, "_5118_Wyc_Box");
        this.$messenger.targets["_5118_Wyc_Box"].send(type, msg);
      },
      getHotLineHeight(windowheight, id, number = 0, type = "id") {
        let toolbar = document.querySelector(".el-header");

        let editorToolbarHeight = 0;
        if (toolbar !== null && toolbar !== undefined) {
          editorToolbarHeight = toolbar.offsetHeight;
        }

        let righttitle = document.querySelector(".tLeft");

        let righttitleHeight = 0;
        if (righttitle !== null && righttitle !== undefined) {
          righttitleHeight = righttitle.offsetHeight;
        }
        let editorStatusBarHeight = 145;
        let realHeight =
          windowheight -
          editorToolbarHeight -
          editorStatusBarHeight -
          number -
          righttitleHeight;
        let getBox = null;
        if (type === "id") {
          getBox = document.getElementById(id);
        } else {
          getBox = document.getElementsByClassName(id)[0];
        }

        if (getBox) getBox.style.height = realHeight-60 + "px";
      },
      hanldeKeyword(keywords) {
        let wordMatchString = "";
        let words = [].concat(keywords);
        words.forEach(item => {
          let transformString = item;
          if (keywords.indexOf(".") === -1) {
            transformString = item.replace(/[.[*?+^$|()/]|\]|\\/g, "\\$&");
          }

          if (transformString.length > 1) {
            let keywordsnum = 1;
            let keywordsallexp = "";
            for (let i = 0; i < transformString.length; i++) {
              let key1 = transformString.substring(i, keywordsnum);
              key1 === "." ? (key1 = "\\" + key1) : key1;
              keywordsnum += 1;

              i > 0
                ? (keywordsallexp += "[\\S|\\s]{0,5}" + key1)
                : (keywordsallexp += key1);
            }
            wordMatchString += `|(${keywordsallexp})`;
          } else {
            wordMatchString += `|(${transformString})`;
          }
        });

        wordMatchString = wordMatchString.substring(1);
        // 用于再次高亮与关闭的关键字作为一个整体的匹配正则
        var wholePattern = new RegExp(`^${wordMatchString}$`, "i");
        // 用于第一次高亮的关键字匹配正则
        // var pattern = new RegExp(wordMatchString, "i");
        return [wordMatchString, wholePattern];
      },
      copy(btn) {
        let _this = this;
        let clipboard = new this.Clipboard(btn);
        clipboard.on("success", () => {
          // 释放内存
          clipboard.destroy();
          _this.$message({
            showClose: true,
            message: "文本复制成功",
            type: "success"
          });
        });
        clipboard.on("error", () => {
          // 不支持复制
          _this.$message({
            message: "该浏览器不支持自动复制",
            showClose: true,
            type: "warning"
          });
          // 释放内存
          clipboard.destroy();
        });
      },
      setLastEditContent(docList) {
        localStorage.setItem("lastEditorContent", JSON.stringify(docList));
      },
      getLastEditContent() {
        let getList = localStorage.setItem("lastEditorContent");
        if (getList) {
          getList = JSON.parse(getList);
        }
        return getList;
      },
      setSessionDocId(docid) {
        sessionStorage.setItem("docId", docid);
      },
      getSessionDocId() {
        return sessionStorage.getItem("docId");
      },
      fixHeight(windowheight, id, number = 0, type = "id", num = 0) {
        let toolbar = document.querySelector(".el-header");

        let editorToolbarHeight = 0;
        if (toolbar !== null && toolbar !== undefined) {
          editorToolbarHeight = toolbar.offsetHeight;
        }

        let realHeight = windowheight - editorToolbarHeight - number;
        let getBox = null;
        if (type === "id") {
          getBox = document.getElementById(id);
        } else if (type === "class") {
          getBox = document.getElementsByClassName(id)[num];
        } else {
          getBox = document.getElementsByTagName(id)[num];
        }
        if (getBox) getBox.style.height = realHeight-60 + "px";
        return realHeight;
      },
      Trim(str) {
        return str.replace(/(^\\s*)|(\\s*$)/gi, "");
      },
      textHighlight(txt, highlightArray) {
        highlightArray.forEach(m => {
          var light = '<span class="highlight">' + m + "</span>";
          txt = txt.replace(m, light);
        });
        return txt;
      },
      scrollTop(id, type = "id") {
        if (type === "id") {
          document.getElementById(id).scrollTop = 0;
        } else {
          document.getElementsByClassName(id)[0].scrollTop = 0;
        }
      },
      sortdown(name) {
        return function(obj1, obj2) {
          let val1 = obj1[name];
          let val2 = obj2[name];
          return val2 - val1;
        };
      },
      imageShowUrl(url) {
        let num = Math.ceil(Math.random() * 3);
        return url.indexOf("5ceimg.com") === -1 && url.indexOf("5ce.com") === -1
          ? url === ""
            ? "//tmp.5ceimg.com/default-cover.png"
            : "//img-0" + num + ".proxy.5ce.com/?url=" + url + "!158_100&q=75"
          : url;
      },
      imgError(item) {
        item.coverImage = "//tmp.5ceimg.com/default-cover.png";
      },
      clearClass(getContent) {
        let reg = /<span class="proBackColor">([^>]*?)<\/span>/gi;
        let matches = [];
        while ((matches = reg.exec(getContent)) != null) {
          getContent = getContent.replace(matches[0], matches[1]);
        }
        reg = /<span class="errBackColor">([^>]*?)<\/span>/gi;
        matches = [];
        while ((matches = reg.exec(getContent)) != null) {
          getContent = getContent.replace(matches[0], matches[1]);
        }
        reg = /<span class="[oriBackColor1|oriBackColor2|oriBackColor3]+">([^>]*?)<\/span>/gi;
        matches = [];
        while ((matches = reg.exec(getContent)) != null) {
          getContent = getContent.replace(matches[0], matches[1]);
        }
        return getContent;
      },
      getUserLevel(level) {
        if (level === 2) return "VIP";
        if (level === 6) return "VIP";
        if (level === 100) return "SVIP";
      },
      getUserNextLevel(level) {
        if (level === 2) return "VIP";
        if (level === 6) return "SVIP";
        if (level === 100) return "SVIP";
      },
      //时间过滤+0
      appendZero(obj) {
        if (obj < 10) {
          return "0" + obj;
        } else {
          return obj;
        }
      },
      getTime() {
        let date1 = new Date();
        let year = date1.getFullYear();
        let month = date1.getMonth() + 1;
        let day = date1.getDate();
        let hours = date1.getHours();
        let minutes = date1.getMinutes();
        let seconds = date1.getSeconds();
        return (
          this.appendZero(year) +
          "-" +
          this.appendZero(month) +
          "-" +
          this.appendZero(day) +
          " " +
          this.appendZero(hours) +
          ":" +
          this.appendZero(minutes) +
          ":" +
          this.appendZero(seconds)
        );
      },
      newGetTime(type) {
        let date1 = new Date();
        let year = date1.getFullYear();
        let month = date1.getMonth() + 1;
        let day = date1.getDate();
        let hours = date1.getHours();
        let minutes = date1.getMinutes();
        let seconds = date1.getSeconds();
        let getDate = year;
        if (type === "day") {
          getDate = year + "" + month + "" + day;
        }
        if (type === "hour") {
          getDate = year + "" + month + "" + day + "" + hours;
        }
        if (type === "minutes") {
          getDate = year + "" + month + "" + day + "" + hours + "" + minutes;
        }
        if (type === "seconds") {
          getDate =
            year +
            "" +
            month +
            "" +
            day +
            "" +
            hours +
            "" +
            minutes +
            "" +
            seconds;
        }
        return getDate;
      },
      bjDate(date, date1) {
        let dateN = new Date(date);
        let dateN2 = new Date(date1);
        if (dateN.getTime() - dateN2.getTime() > 0) {
          return true;
        } else {
          return false;
        }
      },
      //转义HTML
      escape2Html(str) {
        var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
          return arrEntities[t];
        });
      }
    }
  });
};

module.exports = Common;
